import { type QueryHookOptions, useQuery } from "@apollo/client";
import { TagsListQuery } from "../graphql/queries";
import type { TagsListQueryType } from "@/types/graphql/partner.generated";

export const useTagsQuery = (options?: QueryHookOptions<TagsListQueryType>) => {
  return useQuery<TagsListQueryType>(TagsListQuery, options);
};
